import React from "react"
import Layout from "./layout-v2"
import { Link, ModalRoutingContext } from 'gatsby-plugin-modal-routing-3'

import { GrClose } from 'react-icons/gr'

const ConditionalLayout = ({ children, ...rest }) => (
  <ModalRoutingContext.Consumer>
    {({ modal, closeTo }) => (
      modal ? (
        <React.Fragment>
          <Link to={closeTo} style={{ display: 'block', width: '100%', textAlign: 'right' }}>
            <GrClose size={24}/>
          </Link>
          {children}
        </React.Fragment>
      ) : (
        <Layout { ...rest }>
          {children}
        </Layout>
      )
    )}
  </ModalRoutingContext.Consumer>
)

export default ConditionalLayout